module.exports = __webpack_public_path__ + "static/media/faqBalance-es-tl.ce054137.vtt";